import useSafeState from '../utils/safe-state';
import * as React from 'react'
import {BrowserRouter as Router, Link, Route, Switch} from 'react-router-dom';
import {useKeycloak} from '@react-keycloak/web'
import {PrivateRoute} from './utils'
import {Button, Col, Dropdown, Form, Input, Layout, Menu, message, Modal, Row, Tooltip} from 'antd';
import SubMenu from "antd/es/menu/SubMenu";


import {Trans} from "@lingui/macro";

import {i18n} from '@lingui/core'

import "../routes/App.css";
import './App.css';
import 'antd/dist/antd.css';

import "../routes/index.css";
import logo from "../images/login_banner.png"
import {
    DatabaseOutlined, DownloadOutlined,
    HomeOutlined,
    MenuFoldOutlined, MenuUnfoldOutlined, QrcodeOutlined, BarcodeOutlined,
    CopyOutlined, SnippetsOutlined, HistoryOutlined, ShoppingCartOutlined, ContactsOutlined
} from "@ant-design/icons";

import {
    ShopOutlined, ToolOutlined, DollarOutlined, CarOutlined,
    MessageOutlined,PullRequestOutlined,GlobalOutlined, AppstoreAddOutlined,
    CalendarOutlined,
    AlertOutlined,
    CopyrightOutlined,
    ControlOutlined,
    ReconciliationOutlined,
    LogoutOutlined,
    QuestionCircleOutlined,
    SwapOutlined,
    TeamOutlined,
    ArrowUpOutlined,
    FileProtectOutlined,
    FileOutlined, SettingOutlined, DoubleRightOutlined, DoubleLeftOutlined, VideoCameraOutlined, EnvironmentOutlined, AppstoreOutlined, MailOutlined, SafetyCertificateOutlined, StockOutlined, FileTextOutlined
} from '@ant-design/icons/lib';

import {Footer} from "antd/lib/layout/layout";
import LandingScreen from "../pages/landing/landing";
import isAuthorized from "../utils/is-authorized";
import Icon from '@ant-design/icons';
import {useAxios} from "../utils/hooks";
import {useCallback, useState} from "react";
import {AxiosResponse} from "axios";
import QRCode from "qrcode";
import {antdContext} from "../utils/antdContext";
import SupportIcon from "../components/icons/support-icon";
import DashboardScreen from "../screens/dashboard/dashboard";
import OrdersScreen from "../screens/orders/orders";
import OrderReceivingsScreen from "../screens/orderreceivings/orderreceivings";
import SalesScreen from "../screens/sales/sales";
import ConfigurationsScreen from "../screens/configurations/configurations";
import UserManagementScreen from "../screens/usermanagement/usermanagement";
import DdsAssignmentRulesScreen from "../screens/ddsassignmentrules/ddsassignmentrules";
import LocationAssignmentRulesScreen from "../screens/locationassignmentrules/locationassignmentrules";
import MscStockScreen from "../screens/mscstock/mscstock";
import ItemTransformsScreen from "../screens/itemtransforms/itemtransforms";
import SuppliersScreen from "../screens/masterdata/suppliers/suppliers";
import ItemsScreen from "../screens/masterdata/items/items";
import LocationsScreen from "../screens/masterdata/locations/locations";
import OnboardingScreen from "../screens/onboarding/onboarding";
import OnboardingFinishScreen from "../screens/onboarding/onboardingfinish";
import {openNotification} from "../utils/openNotification";
import MyBusinessProfileScreen from "../screens/mybusinessprofile/mybusinessprofile";
import EmailsScreen from "../screens/emails/emails";
import AutoChecksScreen from "../screens/autochecks/autochecks";
import MscStockMovementsScreen from "../screens/mscstockmovements/mscstockmovements";
import LegacyStockScreen from "../screens/masterdata/legacy-stock/legacy-stock";
import DdsRequirementsScreen from "../screens/ddsrequirements/ddsrequirements";
import PublicDdsSearch from "../screens/public/PublicDdsSearch";



const {Header, Sider, Content} = Layout;

export const AppRouter = () => {

    const SupportIco = (props: any) => <Icon component={SupportIcon} {...props} />;

    const {initialized, keycloak} = useKeycloak();
    const myStorage = window.localStorage;
    const axiosInstance = useAxios(process.env.REACT_APP_API_BASE_URL + "");

    const [isModalVisible, setIsModalVisible] = useState(false);
    const [qrCode, setQrCode] = useState<any>();
    const [onboardingStatus, setOnboardingStatus] = React.useState<string | null>();


    const [loggedUser, setLoggedUser] = useSafeState<any>('')
    const [supplierCode, setSupplierCode] = useSafeState<any>('')
    const [collapsed, setCollapsed] = useSafeState(false)
    const toggleCollapse = () => {
        setCollapsed(!collapsed);
    }

    const showModal = () => {
        setIsModalVisible(true);
    };


    const handleCancel = () => {
        setIsModalVisible(false);
    };

    // const [form] = Form.useForm();
    // form.resetFields();

    React.useEffect(() => {

        if (keycloak && keycloak.tokenParsed) {

            let obj: any = JSON.parse(JSON.stringify(keycloak.tokenParsed));
            if (keycloak.tokenParsed != null) {
                setLoggedUser(obj.preferred_username);
                localStorage.setItem('username', obj.preferred_username);
                setSupplierCode((keycloak.tokenParsed as any).supplierCode);
                localStorage.setItem('supplierCode', (keycloak.tokenParsed as any).supplierCode);
            }
        }

        if (axiosInstance.current != null && keycloak && keycloak.authenticated) {

            axiosInstance.current
                .get('/resource/onboarding/get-onboarding-status')
                .then((response) => {
                    setOnboardingStatus(response.data);
                })
                .catch((error: any) => {
                    openNotification('error', error);
                });
        }

    }, [initialized, keycloak]);

    const openWikiJs = () => {

        let pathname =
            ((window.location.pathname == "/" || window.location.pathname == "/landing")
                ? "/home"
                : window.location.pathname).replace( new RegExp("[0-9]+","gm"),"");

        window.open(process.env.REACT_APP_WIKI_URL + pathname, '_blank');
    }

    if (!initialized) {
        return <div>
            <Trans>Loading...</Trans>
        </div>
    }


    const menu = (
        <Menu>
            <Menu.Item
                onClick={() => {
                keycloak.redirectUri = window.location.origin;
                keycloak.logout();
                localStorage.clear();
            }}>
                <span style={{
                    fontSize: "small",
                    cursor: "pointer",
                    marginRight: 20
                }}>
                    <span style={{marginRight: 5}}><LogoutOutlined/></span><span><Trans>Logout</Trans></span></span>
            </Menu.Item>
        </Menu>
    );

    return (

        <Router>
            <Layout style={{minHeight: "100vh"}}>
                <Sider trigger={null} hidden={onboardingStatus != 'COMPLETED'} collapsible collapsed={collapsed} width={250} theme={"light"}>
                    <Menu theme={"light"} mode="inline" defaultSelectedKeys={['1']}>

                        {isAuthorized(keycloak,["EUDR_ADMIN", "EUDR_SUPPL_ADMIN", "EUDR_SUPPL_USER"]) ?
                            <Menu.Item key="1" icon={<HomeOutlined/>}>
                                <Link to="/dashboard"><Trans>Home</Trans></Link>
                            </Menu.Item>
                            : <></>
                        }

                        {isAuthorized(keycloak,["EUDR_ADMIN", "EUDR_SUPPL_ADMIN", "EUDR_SUPPL_USER"]) ?
                            <Menu.Item key="2" icon={<ShoppingCartOutlined />}>
                                <Link to="/orders"><Trans>Orders</Trans></Link>
                            </Menu.Item>
                            : <></>
                        }

                        {isAuthorized(keycloak,["EUDR_ADMIN", "EUDR_SUPPL_ADMIN", "EUDR_SUPPL_USER"]) ?
                            <Menu.Item key="3" icon={<AppstoreAddOutlined />}>
                                <Link to="/order-receivings"><Trans>Order Receivings</Trans></Link>
                            </Menu.Item>
                            : <></>
                        }

                        {isAuthorized(keycloak,["EUDR_ADMIN"]) ?
                            <Menu.Item key="4" icon={<DollarOutlined />}>
                                <Link to="/sales"><Trans>Sales</Trans></Link>
                            </Menu.Item>
                            : <></>
                        }

                        {isAuthorized(keycloak,["EUDR_ADMIN"]) ?
                            <Menu.Item key="5" icon={<ToolOutlined />}>
                                <Link to="/item-transforms"><Trans>Item Transforms</Trans></Link>
                            </Menu.Item>
                            : <></>
                        }

                        {isAuthorized(keycloak,["EUDR_ADMIN"]) ?
                            <Menu.Item key="6" icon={<ShopOutlined />}>
                                <Link to="/msc-stock"><Trans>Msc Stock</Trans></Link>
                            </Menu.Item>
                            : <></>
                        }

                        {isAuthorized(keycloak,["EUDR_ADMIN", "EUDR_SUPPL_ADMIN", "EUDR_SUPPL_USER"]) ?
                            <Menu.Item key="7" icon={<GlobalOutlined />}>
                                <Link to="/location-assignment-rules"><Trans>Location Assignment Rules of Relevant Commodity</Trans></Link>
                            </Menu.Item>
                            : <></>
                        }

                        {isAuthorized(keycloak,["EUDR_ADMIN", "EUDR_SUPPL_ADMIN", "EUDR_SUPPL_USER"]) ?
                            <Menu.Item key="8" icon={<PullRequestOutlined />}>
                                <Link to="/dds-assignment-rules"><Trans>DDS Assignment Rules</Trans></Link>
                            </Menu.Item>
                            : <></>
                        }

                        <SubMenu key="MasterDataSubMenu" icon={<DatabaseOutlined/>} title={<Trans>Data Maintenance</Trans>}>

                            {isAuthorized(keycloak,["EUDR_ADMIN"])
                            ? <Menu.Item key="9" icon={<CarOutlined />}>
                                    <Link to="/suppliers"><Trans>Suppliers</Trans></Link>
                                </Menu.Item>

                                : <></>
                            }
                            <Menu.Item key="10" icon={<AppstoreOutlined />}>
                                <Link to="/items"><Trans>Items</Trans></Link>
                            </Menu.Item>
                            <Menu.Item key="11" icon={<EnvironmentOutlined />}>
                                <Link to="/locations"><Trans>Locations of Relevant Commodity</Trans></Link>
                            </Menu.Item>
                            <Menu.Item key="12" icon={<HistoryOutlined />}>
                                <Link to="/legacy-stock"><Trans>Legacy Stock</Trans></Link>
                            </Menu.Item>
                        </SubMenu>

                        {isAuthorized(keycloak,["EUDR_ADMIN", "EUDR_SUPPL_ADMIN"]) ?
                            <Menu.Item key="13" icon={<TeamOutlined />}>
                                <Link to="/user-management"><Trans>User Management</Trans></Link>
                            </Menu.Item>
                            : <></>
                        }

                        {isAuthorized(keycloak,["EUDR_ADMIN"]) ?
                            <Menu.Item key="14" icon={<SettingOutlined/>}>
                                <Link to="/configurations"><Trans>Configurations</Trans></Link>
                            </Menu.Item>
                            : <></>
                        }

                        {isAuthorized(keycloak,["EUDR_ADMIN"]) ?
                            <Menu.Item key="15" icon={<MailOutlined/>}>
                                <Link to="/emails"><Trans>Emails</Trans></Link>
                            </Menu.Item>
                            : <></>
                        }

                        {isAuthorized(keycloak,["EUDR_ADMIN"]) ?
                            <Menu.Item key="16" icon={<SafetyCertificateOutlined/>}>
                                <Link to="/auto-checks"><Trans>Auto Checks</Trans></Link>
                            </Menu.Item>
                            : <></>
                        }

                        {isAuthorized(keycloak,["EUDR_ADMIN"]) ?
                            <Menu.Item key="17" icon={<FileTextOutlined/>}>
                                <Link to="/dds-requirements"><Trans>DDS Requirements</Trans></Link>
                            </Menu.Item>
                            : <></>
                        }

                        {isAuthorized(keycloak,["EUDR_ADMIN"]) ?
                            <Menu.Item key="18" icon={<StockOutlined/>}>
                                <Link to="/msc-stock-movements"><Trans>MSC Stock Movements</Trans></Link>
                            </Menu.Item>
                            : <></>
                        }

                        {isAuthorized(keycloak,["EUDR_ADMIN", "EUDR_SUPPL_ADMIN"]) ?
                            <Menu.Item key="19" icon={<ShopOutlined/>}>
                                <Link to="/mybusinessprofile"><Trans>My Business Profile</Trans></Link>
                            </Menu.Item>
                            : <></>
                        }

                    </Menu>
                </Sider>
                <Layout className="site-layout ">
                    <Header className="site-layout-background" style={{textAlign: "center", padding: 0}}>
                        <Row>
                            <Col span={10} >
                                {
                                    onboardingStatus == 'COMPLETED'
                                        ? React.createElement(collapsed ? MenuUnfoldOutlined : MenuFoldOutlined, {
                                        className: 'trigger',
                                        onClick: toggleCollapse,
                                        style: {float: 'left'}})
                                        : <></>
                                }
                            </Col>
                            <Col span={4}>
                                    <span style={{textAlign: "center", width: 125}}>
                                        <img src={logo} style={{height: 60}}/>
                                    </span>
                            </Col>
                            <Col span={10}>
                                    <span style={{float: 'right'}}>

                                        {
                                            onboardingStatus == 'COMPLETED'
                                                ?
                                                <>
                                                    <span style={{marginRight: 20}}><Trans>Supplier</Trans>: {localStorage.getItem('supplierCode') == 'undefined' ? '-' : localStorage.getItem('supplierCode')}</span>
                                                    <Tooltip placement="bottom" title={<Trans>Help</Trans>}>
                                            <span style={{verticalAlign: 'middle'}}>
                                                <QuestionCircleOutlined style={{marginRight: 20, fontSize: 'x-large'}}
                                                                        onClick={() => openWikiJs()}/>
                                            </span>
                                                    </Tooltip>

                                                    <Tooltip placement="bottom" title={<Trans>Support</Trans>}>
                                            <span style={{verticalAlign: 'middle'}}>
                                                <a style={{textDecoration: "none", color: "black"}} href={"mailto:support@logicloud.hu"}><SupportIco style={{ marginRight: 20, fontSize: 'x-large' }} /></a>
                                            </span>
                                                    </Tooltip>

                                                    <span
                                                        className={process.env.REACT_APP_ENVIRONMENT}>{process.env.REACT_APP_ENVIRONMENT}</span>

                                                    <Dropdown overlay={menu} placement="bottomLeft">
                                                        <Button style={{border: 0}}><span
                                                            style={{fontSize: 'large'}}>{loggedUser} </span></Button>
                                                    </Dropdown>
                                                </>
                                                : <></>
                                        }

                                    </span>
                            </Col>
                        </Row>
                    </Header>
                    <Content
                        className="site-layout-background"
                        style={{
                            margin: '12px 8px',
                            padding: 20
                        }}
                    >
                        <Switch>
                            {<PrivateRoute roles={["EUDR_ADMIN", "EUDR_SUPPL_ADMIN", "EUDR_SUPPL_USER"]} exact path="/" component={DashboardScreen}/>}
                            {<PrivateRoute roles={["EUDR_ADMIN", "EUDR_SUPPL_ADMIN", "EUDR_SUPPL_USER"]} exact path="/dashboard" component={DashboardScreen}/>}
                            {<PrivateRoute roles={["EUDR_ADMIN", "EUDR_SUPPL_ADMIN", "EUDR_SUPPL_USER"]} exact path="/orders" component={OrdersScreen}/>}
                            {<PrivateRoute roles={["EUDR_ADMIN", "EUDR_SUPPL_ADMIN", "EUDR_SUPPL_USER"]} exact path="/order-receivings" component={OrderReceivingsScreen}/>}
                            {<PrivateRoute roles={["EUDR_ADMIN", "EUDR_SUPPL_ADMIN", "EUDR_SUPPL_USER"]} exact path="/location-assignment-rules" component={LocationAssignmentRulesScreen}/>}
                            {<PrivateRoute roles={["EUDR_ADMIN", "EUDR_SUPPL_ADMIN", "EUDR_SUPPL_USER"]} exact path="/dds-assignment-rules" component={DdsAssignmentRulesScreen}/>}
                            {<PrivateRoute roles={["EUDR_ADMIN", "EUDR_SUPPL_ADMIN", "EUDR_SUPPL_USER"]} exact path="/items" component={ItemsScreen}/>}
                            {<PrivateRoute roles={["EUDR_ADMIN", "EUDR_SUPPL_ADMIN", "EUDR_SUPPL_USER"]} exact path="/locations" component={LocationsScreen}/>}
                            {<PrivateRoute roles={["EUDR_ADMIN", "EUDR_SUPPL_ADMIN", "EUDR_SUPPL_USER"]} exact path="/legacy-stock" component={LegacyStockScreen}/>}

                            {<PrivateRoute roles={["EUDR_ADMIN", "EUDR_SUPPL_ADMIN"]} exact path="/user-management" component={UserManagementScreen}/>}
                            {<PrivateRoute roles={["EUDR_ADMIN", "EUDR_SUPPL_ADMIN"]} exact path="/mybusinessprofile" component={MyBusinessProfileScreen}/>}

                            {<PrivateRoute roles={["EUDR_SUPPL_ADMIN"]} exact path="/onboardingfinish" component={OnboardingFinishScreen}/>}

                            {<PrivateRoute roles={["EUDR_ADMIN"]} exact path="/sales" component={SalesScreen}/>}
                            {<PrivateRoute roles={["EUDR_ADMIN"]} exact path="/item-transforms" component={ItemTransformsScreen}/>}
                            {<PrivateRoute roles={["EUDR_ADMIN"]} exact path="/msc-stock" component={MscStockScreen}/>}
                            {<PrivateRoute roles={["EUDR_ADMIN"]} exact path="/configurations" component={ConfigurationsScreen}/>}
                            {<PrivateRoute roles={["EUDR_ADMIN"]} exact path="/emails" component={EmailsScreen}/>}
                            {<PrivateRoute roles={["EUDR_ADMIN"]} exact path="/auto-checks" component={AutoChecksScreen}/>}
                            {<PrivateRoute roles={["EUDR_ADMIN"]} exact path="/dds-requirements" component={DdsRequirementsScreen}/>}
                            {<PrivateRoute roles={["EUDR_ADMIN"]} exact path="/msc-stock-movements" component={MscStockMovementsScreen}/>}
                            {<PrivateRoute roles={["EUDR_ADMIN"]} exact path="/suppliers" component={SuppliersScreen}/>}

                            {<Route exact path="/onboarding" component={OnboardingScreen}/>}
                            {<Route exact path="/public/dds-search" component={PublicDdsSearch}/>}

                        </Switch>
                    </Content>
                    <Footer style={{ textAlign: "center", fontSize: 10, paddingTop: 0, paddingRight: 10, paddingLeft: 10, paddingBottom: 9}}>
                        <Row>
                            <Col span={8}></Col>
                            <Col span={8}>
                                <CopyrightOutlined />{' '}
                                <span>
                                    {' '}
                                    2026 Copyright LogiCloud Kft. | Created by{' '}
                                    <a href="https://www.logicloud.hu" target="_blank" >LogiCloud Kft.</a>
                                </span>
                            </Col>
                            <Col span={8} style={{ textAlign: 'right' }}>
                                {process.env.REACT_APP_VERSION + '-SNAPSHOT'}
                            </Col>
                        </Row>
                    </Footer>
                </Layout>
            </Layout>
        </Router>
    )
}
